import { render, staticRenderFns } from "./ContactsUs.vue?vue&type=template&id=0744dce8"
import script from "./ContactsUs.vue?vue&type=script&lang=ts"
export * from "./ContactsUs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports